import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";

import { useMutation } from "@apollo/client";
import { GET_APP_INFO_AND_ACCOUNTS } from "../../../api/gql";
import { UPDATE_CONFIRM_STEP } from "./gql";

// Components
import PersonalDetails from "./PersonalDetails";
import ConfirmV2Form from "./ConfirmV2Form";
import LinkBankAccounts from "../linkBank/LinkBankAccounts";

import withQuery from "../wrappers/gql/withQuery";
import Loading from "../../common/Loading";
import { GENERIC_ERROR_MESSAGE, URI_PATHS } from "../../../constants";

const ConfirmV2 = ({ data: applicationInfo, refetchQuery: fetchAccounts }) => {
  const history = useHistory();

  const { getBankAccounts } = applicationInfo;
  const { accountsByLogin: totalAccounts } = getBankAccounts;
  const accountsByLogin = totalAccounts || [];

  const [updateConfirmStep, { loading: updateConfirmStepLoading }] = useMutation(UPDATE_CONFIRM_STEP);

  const [errorNetwork, setErrorNetwork] = useState("");

  const _completeStep = useCallback(async () => {
    setErrorNetwork("");
    try {
      await updateConfirmStep();
    } catch (err) {
      setErrorNetwork(GENERIC_ERROR_MESSAGE);
      return;
    }

    history.push(URI_PATHS.DECISION);
  }, []);

  return (
    <div className="outerStack-mobile sm:outerStack">
      <div className="innerStack">
        <div className="stepDescriptionText">
            Review Your Application
        </div>
        {updateConfirmStepLoading && <Loading />}
        <PersonalDetails />
        <div className="my-4 pt-2">
          {errorNetwork && <div className="errorText">{errorNetwork}</div>}
          <LinkBankAccounts
            accountsByLogin={accountsByLogin}
            fetchAccounts={fetchAccounts}
            setErrorNetwork={setErrorNetwork}
          />
        </div>
        <ConfirmV2Form _completeStep={_completeStep} />
      </div>
    </div>
  );
};

export default withQuery(GET_APP_INFO_AND_ACCOUNTS)(ConfirmV2);